import React from 'react'

import { Outlet } from 'react-router-dom'

import { Timer } from '../../features/simulator/SimulatorHeader/Timer/Timer'

import style from './Main.module.css'

import { Categories } from 'features/dashboard/Categories/Categories'

export const Main = () => {
  return (
    <main className={style.main}>
      <div className="container">
        <div className={style.grid}>
          <Categories />
          <Outlet />
        </div>
      </div>
    </main>
  )
}
